/**
 * @module experience/device-assessment
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */

export const DEVICE_ASSESSSMENT_CONSTANT = {
  SUBTOTAL: 'SUBTOTAL',
  TOTAL: 'TOTAL',
  TAX_AND_FEE: 'TAX_AND_FEE',
  WARRANTY: 'WARRANTY',
  REMORSE: 'REMORSE',
  EXCHANGE: 'EXCHANGE',
  ENABLE: 'enable',
  RETAIL: 'RETAIL',
  DEVICE: 'DEVICE',
  EPIN: 'E-PIN',
  D2A: 'D2AND',
  SIMCARD: 'simcard',
  HANDSET: 'handset',
  ASSESITEM: 'assesItem',
  TABLET: 'tablet',
  MOBILEINTERNET: 'mobileinternet',
  REMORSE_RETURN_SELECTED_TYPE: 'return',
  REMORSE_EXCHANGE_SELECTED_TYPE: 'exchange',
  RETURN_REASON: 'RETURN',
  EXCHANGE_REASON: 'EXCHANGE',
  UNSELLABLE_REASON: 'UNSELLABLE',
  MANAGERATEPLAN: 'MANAGERATEPLAN',
  MANAGEADDON: 'MANAGEADDON',
  SUBMIT: 'SUBMIT',
  REFUND: 'REFUND',
  VALIDATE_DEVICE_LINK: 'device-assessment/validate-device',
  INITIAL_COUNT: 0,
  LAST_COUNT: 11,
  ZERO: 0,
  ONE: 1,
  Two: 2,
  THREE: 3,
  TWO: '2',
  FIVE: '5',
  HARDSTOP: 'HARDSTOP',
  DATE_FORMAT: 'MM/DD/YYYY',
  ACCESSORY: 'ACCESSORY',
  DEVICE_ASSESSMENT_LINK: '/device-assessment',
  ALLOWED: 'ALLOWED',
  POST: 'POST',
  IMMEDIATE: 'Immediate',
  BYPASS: 'BYPASSED',
  PASS: 'PASS',
  YES: 'YES',
  NO: 'NO',
  APPLE: 'apple',
  OVERRIDE: 'OVERRIDE',
  DEVICE_ASSESSMENT_MODULE_NAME: 'DeviceAssessmentModule',
  CART_ID: 'CARTID',
  ADD: 'ADD',
  JPAY: 'jpay',
  CASH: 'Cash',
  PAYMENT: 'PAYMENT',
  USD: 'USD',
  NUMBERZERO: '0',
  ASSESS_ITEM_LINK: '/device-assessment/assess-item',
  DESCRIPTION: 'description',
  CODE: 'code',
  HARD: 'HARDCONFLICT',
  SOFT: 'SOFTCONFLICT',
  PASSED: 'PASSED',
  ACTION_UPDATE: 'UPDATE',
  DEVICE_ASSESSMENT_REASON: '/device-assessment/select-reason',
  DEVICE_ASSESMENT_DIAGNOSTIC: '/device-assessment/run-diagnostic',
  WARRANTY_REPLACEMENT: '/warranty-replacement',
  CART_REVIEW: '/cart/review',
  LINE_LANDING: '/line-landing',
  ORDER_SUMMARY: '/order-summary',
  CART_URL: '/cart',
  REMOVE: 'REMOVE',
  LINE_DEVICE: 'LINEDEVICE',
  SHIPPING: 'SHIPPING',
  MASKED_IMEI: 'XXXX',
  CANCEL: 'cancel',
  SECONDARY_CLASS: 'btn btn-secondary',
  APPROVE_OVERRIDE: 'Approve override',
  APPROVE_OVERRIDE_TYPE: 'confirm',
  PRIMARY_CLASS: 'btn btn-primary',
  SELLABLECODE: 'SR305',
  PRIMARY_BUTTON: 'btn btn-primary',
  SECONDARY_BUTTON: 'btn btn-secondary',
  ON: 'ON',
  BAGS: 'BAGS',
  OVERRIDE_INELIGIBLE_RETURN: 'OVERRIDE_INELIGIBLE_RETURN',
  BYPASS_REMORSE_RETURN_RESTR: 'BYPASS_REMORSE_RETURN_RESTR',
  CONTINUE: 'Continue',
  VIEWCART: 'ViewCart',
  SHARED: 'shared',
  BUTTON_CANCEL_ID: 'cancel',
  BUTTON_OVERRIDE_ID: 'approve_override',
  BUTTON_OVERRIDE_TYPE: 'confirm',
  NOT_ALLOWED: 'NOT ALLOWED',
  YES_CONSTANT: 'Yes',
  NO_CONSTANT: 'No',
  ACTIVATION: 'ACTIVATION',
};
/**
 * Enum values for conflict type
 */
export enum ConflictType {
  HARD,
  SOFT,
}

export const CART_METHOD = {
  POST: 'POST',
  PUT: 'PUT',
};
